/**
 * TRACKING CONSTANTS
 */

export const AMPLITUDE_GA_TRACKING_CATEGORY = 'Banner Trial Subscription';
export const STRIP_TRIAL_SUBSCRIPTION = 'Strip Trial Subscription';

export const POST_TRIAL_SUBSCRIPTION_BANNER_FEATURE = 'Post trial';
export const ON_TRIAL_SUBSCRIPTION_BANNER_FEATURE = 'On trial';

export const CLICK_STRIP_TRIAL_SUBSCRIPTION_ACTION =
    'Clicked Strip Trial Subscription';

export const VIEW_SUBSCRIPTION_BANNER_ACTION = 'Viewed Subscription Banner';
export const CLICK_SUBSCRIPTION_BANNER_SUBSCRIPTION_ACTION =
    'Clicked Subscription Banner Subscription';
export const CLICK_SUBSCRIPTION_BANNER_DISMISS_ACTION =
    'Clicked Subscription Banner Dismissed';

// LISTING TRACKING CONSTANTS

export const LISTING_AMPLITUDE_TRACKING_CATEGORY = 'Promote Event Banner';
export const LISTING_VIEW_PROMOTE_BANNER_ACTION = 'Viewed Promote Event Banner';
export const LISTING_SOURCE = 'Listing Page';
export const LISTING_CLICK_PROMOTE_ACTION = 'Clicked Promote Event Banner';
